var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlanDeSalud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15L16.368 12.132C16.4524 12.0477 16.4999 11.9333 16.5 11.814V7.875C16.5 7.57663 16.3815 7.29048 16.1705 7.0795C15.9595 6.86853 15.6734 6.75 15.375 6.75C15.0766 6.75 14.7905 6.86853 14.5795 7.0795C14.3685 7.29048 14.25 7.57663 14.25 7.875V11.25",
    stroke: "#05294F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12L14.1435 11.3565C14.1774 11.3228 14.2043 11.2828 14.2226 11.2386C14.2409 11.1944 14.2502 11.1471 14.25 11.0992C14.2495 11.0319 14.2304 10.966 14.195 10.9087C14.1596 10.8514 14.109 10.805 14.049 10.7745L13.7167 10.6088C13.4353 10.468 13.1166 10.4194 12.806 10.4697C12.4953 10.52 12.2084 10.6668 11.9857 10.8893L11.3145 11.5605C11.0332 11.8417 10.8751 12.2232 10.875 12.621V15M4.5 15L1.632 12.132C1.54758 12.0477 1.50011 11.9333 1.5 11.814V7.875C1.5 7.57663 1.61853 7.29048 1.8295 7.0795C2.04048 6.86853 2.32663 6.75 2.625 6.75C2.92337 6.75 3.20952 6.86853 3.4205 7.0795C3.63147 7.29048 3.75 7.57663 3.75 7.875V11.25",
    stroke: "#05294F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12L3.8565 11.3565C3.7893 11.2876 3.75117 11.1955 3.75 11.0992C3.75 10.962 3.828 10.8368 3.951 10.7745L4.28325 10.6088C4.56473 10.468 4.88335 10.4194 5.19401 10.4697C5.50466 10.52 5.79162 10.6668 6.01425 10.8893L6.6855 11.5605C6.96682 11.8417 7.12492 12.2232 7.125 12.621V15M10.2502 9H7.74975V7.25025H6V4.74975H7.74975V3H10.2502V4.74975H12V7.25025H10.2502V9Z",
    stroke: "#05294F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanDeSalud);
export default __webpack_public_path__ + "static/media/iconPlanDeSalud.3f0ab643b8e086f7c809ba7ec0953ecc.svg";
export { ForwardRef as ReactComponent };